import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { pipe, zip } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../services/settings.service';
import { Router } from '@angular/router';

/**
 * 用于应用启动时
 * 一般用来获取应用所需要的基础数据等
 */


@Injectable()
export class StartupService {
  constructor(
    private translate: TranslateService,
    public setting: SettingsService,
    private httpClient: HttpClient,
    private router: Router
  ) {


  }

  load(): Promise<any> {

    return new Promise((resolve, reject) => {
 
      zip(
        this.httpClient.get(`./assets/tmp/i18n/${this.setting.defaultLang}.json`),
        this.httpClient.get('./assets/app-data.json'),
      ).pipe(
        // 接收其他拦截器后产生的异常消息
        catchError(([langData, appData]) => {
          resolve(null);
          return [langData, appData];
        }),
      )
        .subscribe(
          ([langData, appData]) => {

            // setting language data
            this.translate.setTranslation(this.setting.defaultLang, langData);
            this.translate.setDefaultLang(this.setting.defaultLang);

            // application data
            const res: any = appData;

            if (!this.setting.app || this.setting.app.version != res.app.version) {
              localStorage.clear();
              // 应用信息：包括站点名、描述、年份
              this.setting.setApp(res.app);
              this.router.navigate(['/passport/login']);

            }
            this.setting.setApp(res.app);

          },
          () => { },
          () => {
            resolve(null);
          },
        );
    });
  }
}
